import { ezsServiceIds, idfServiceIds } from "../config/UserServicesList";
import * as httpClient from "../util/httpClient";
import { AppThunkAction } from ".";
import { UserService } from "./loginService/types";
import * as services from "./service";
export const actionCreators = {
    refreshUserPermission:
        (isPkgChange?: boolean, callback?: any): AppThunkAction<any> =>
        (dispatch, getState) => {
            dispatch({ type: "RELOAD_USER_PERMISSION" });
            IdentifyTuUser(dispatch);
            GetServiceDetails(dispatch, isPkgChange, getState, callback);
        },
};

export function GetServiceDetails(dispatch: any, isPkgChange?: boolean, getState?: any, callback?: any) {
    httpClient
        .sendRequest("GET", `api/userServices/Get-User-Active-Service-Details`)
        .then((data) => {
            const userServiceDetails = {
                hasVpn: data["hasVpn"],
                isBusinessUser: data["isBusinessUser"],
                userServices: MapUserServiceDTO(data["userServiceDTO"]),
                businessProfileStatus: data["businessProfileStatus"],
                isBCMMonitored: data["isBCMMonitored"],
                lmsRedirectUrl: data["lmsRedirectUrl"],
                isNYStateUser: data["isNYStateUser"],
            };
            const ccamService = data["userServiceDTO"].find((service: any) => service.serviceCode === ezsServiceIds.smartSSNTrackerChild);
            const idfccamService = data["userServiceDTO"].find((service: any) => service.serviceCode === idfServiceIds.childCreditActivityMonitoring);
            const isCcamActive = !!ccamService || !!idfccamService ? true : false;
            dispatch({ type: "SET_HAS_CCAM", hasCCAM: isCcamActive });
            dispatch({ type: "GET_USER_SERVICES", userServiceDetails: userServiceDetails });
            if (callback) {
                callback();
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function IdentifyTuUser(dispatch: any) {
    services
        .isTuUser()
        .then((data: any) => {
            dispatch({ type: "SET_IS_TU_USER", isTuUser: data["isTuUser"] });
        })
        .catch(function (error) {
            console.log(error);
        });
}

export const MapUserServiceDTO = (userServiceList?: UserService[]): UserService[] => {
    userServiceList?.map((it: UserService) => {
        if (it.serviceCategory?.toUpperCase() === "CREDIT") {
            const serviceCode = it.serviceCode?.toUpperCase() || "";
            if ((serviceCode.includes("RDPT") || serviceCode.includes("RPT")) && serviceCode.includes("SCORE")) {
                it.isReportAndScore = true;
            } else if (serviceCode.includes("RDPT") || serviceCode.includes("RPT")) {
                it.isReport = true;
            } else if (serviceCode.includes("SCORE")) {
                it.isScore = true;
            }
        }
    });

    return userServiceList || [];
};

/////////////////////////////////////////////
// COMMON INTERFACES REMOVED FROM REDUX STORE
/////////////////////////////////////////////
export interface myAccountServiceStatePII {
    memberShipNumber?: string;
    ein?: string;
    _businessInformation?: _businessInformation;
}

export interface _businessInformation {
    businessName?: string;
    ein?: string;
    fax?: string;
}

export interface userLostWalletStateStatePII {
    walletItemCreditCard?: any;
    walletItemBankAccount?: any;
    walletItemDriverLicence?: any;
    walletItemMedicalCard?: any;
    walletItemGenericIDs?: any;
    walletItemSSN?: any;
    walletItemPassport?: any;
    walletItemCustomerRewardCard?: any;
    walletItemCombination?: any;
    walletItemFamilyMembers?: any;
}

export interface WalletItemFamilyMember {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    relationship?: string;
    dob?: string;
    driverLicenseNumber?: string;
    email?: string;
    generationSuffix?: string;
    isMonitoringItem?: boolean;
    notes?: string;
    recordExtId?: string;
    createdDate?: string;
    ssn?: string;
}

export interface WalletItemCreditCard {
    cardCategory?: string;
    cardHolderName?: string;
    cardType?: string;
    cardNumber?: string;
    cardName?: string;
    expirationDate?: string;
    pin?: string;
    cardLevel?: string;
    webSite?: string;
    customerServicePhoneNumber?: string;
    issuingCountry?: string;
    notes?: string;
    recordExtId?: string;
    idFcardID?: string;
}

export interface WalletItemBankAccount {
    accountType?: string;
    institutionName?: string;
    accountNumber?: string;
    street?: string;
    state?: string;
    city?: string;
    country?: string;
    zip?: string;
    website?: string;
    phoneNumber?: string;
    description?: string;
    hours?: string;
    recordExtId?: string;
    notes?: string;
}

export interface WalletItemGenericID {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    cardType?: string;
    cardNumber?: string;
    issueDate?: string;
    expirationDate?: string;
    description?: string;
    suffix?: string;
    notes?: string;
    recordExtId?: string;
}

export interface WalletItemDriverLicence {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    dateOfBirth?: string;
    driverLicenseNumber?: string;
    address1?: string;
    address2?: string;
    driverLicenseState?: string;
    country?: string;
    sex?: string;
    height?: string;
    issueDate?: string;
    expirationDate?: string;
    conditions?: string;
    class?: string;
    suffix?: string;
    notes?: string;
    recordExtId?: string;
}

export interface WalletItemMedicalCard {
    cardType?: string;
    memberName?: string;
    memberId?: string;
    providerName?: string;
    providerPhoneNumber?: string;
    providerAddress?: string;
    issueDate?: string;
    group?: string;
    bin?: string;
    recordExtId?: string;
}

export interface WalletItemSSN {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    ssn?: string;
    suffix?: string;
    issueDate?: string;
    group?: string;
    bin?: string;
    notes?: string;
    recordExtId?: string;
}

export interface WalletItemPassport {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    passportNumber?: string;
    passportType?: string;
    passportCode?: string;
    issueDate?: string;
    issuingCountry?: string;
    nationality?: string;
    placeOfBirth?: string;
    dateOfBirth?: string;
    expiryDate?: string;
    suffix?: string;
    sex?: string;
    notes?: string;
    recordExtId?: string;
}

export interface WalletItemCustomerRewardCard {
    cardHolderName?: string;
    cardName?: string;
    cardNumber?: string;
    customerServicePhoneNumber?: string;
    webSite?: string;
    pin?: string;
    notes?: string;
    recordExtId?: string;
}

export interface WalletItemCombination {
    itemName?: string;
    itemCombination?: string;
    itemLocation?: string;
    keyLocation?: string;
    notes?: string;
    recordExtId?: string;
}

export interface MonitoringData {
    asset: any;
    "user-id"?: string;
    "ezshield-id"?: string;
    "idf-user-id"?: string;
}
